// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"style_componentWrapper__-_rai"};